module.exports = "/static/assets/0ace6d0c800d1275dc415b967ff1dcc4.png";